import routerOptions0 from "/home/runner/work/medicalclip-frontend/medicalclip-frontend/medicalclip-frontend/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/home/runner/work/medicalclip-frontend/medicalclip-frontend/medicalclip-frontend/src/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}